<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">画像チェックリスト出力</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div class="element-column">
          <div class="column-list">
            <label class="list-input-title">出力リスト</label>
            <div class="list-input-content">
              <app-radio-label id="rdb_Existence" #rdb_Existence [subid]="'rdb_Existence'" groupName="grp_List"
                [(ngModel)]="kymw1800Model.outputType" value='1' [label]="'画像有無リスト'" [autofocus]="true"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-radio-label>
              <app-radio-label groupName="grp_List" id="rdb_VersionCheck" #rdb_VersionCheck [subid]="'rdb_VersionCheck'"
                groupName="grp_List" [(ngModel)]="kymw1800Model.outputType" value='2' [label]="'画像バージョンチェックリスト'"
                [forcedEnabledMode]="'true'" [tabindex]="0"></app-radio-label>
            </div>

            <label class="list-input-title">受注コード</label>
            <div class="list-input-content">
              <app-order-code-text-input id="txti_OrderCode" #txti_OrderCode [subid]="'txti_OrderCode'"
                [(ngModel)]="kymw1800Model.orderCode" [required]="true" [catalogIDField]="txti_DelivCatalog"
                [forcedEnabledMode]="'true'" [tabindex]="0" (ngModelChange)="eventOrderCode_CHANGEHandler()">
              </app-order-code-text-input>
            </div>

            <label class="list-input-title">配達企画回(翌週)</label>
            <div class="list-input-content">
              <input type="text" class="deliv-catalog" id="txti_DelivCatalog" #txti_DelivCatalog readonly/>
            </div>

            <label class="list-input-title">媒体</label>
            <div class="list-input-content">
              <app-plan-medium-type-combo-box id="cmb_MediumType" #cmb_MediumType [subid]="'cmb_MediumType'"
                [(ngModel)]="kymw1800Model.mediumType" [required]="true" [orderCode]="txti_OrderCode.selectedOrderCode"
                [forcedEnabledMode]="'true'" [tabindex]="0" style="width: 100%;">
              </app-plan-medium-type-combo-box>
            </div>

            <label class="list-input-title">会員生協</label>
            <div class="list-input-content">
              <app-checkbox-label label="い" id="ckb_CoopCode_I" #ckb_CoopCode_I [subid]="'ckb_CoopCode_I'"
                layout="relative" [forcedEnabledMode]="'true'" [(ngModel)]="kymw1800Model.ibaraki" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label label="と" id="ckb_CoopCode_To" #ckb_CoopCode_To [subid]="'ckb_CoopCode_To'"
                layout="relative" [forcedEnabledMode]="'true'" [(ngModel)]="kymw1800Model.tochigi" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label label="ぐ" id="ckb_CoopCode_Gu" #ckb_CoopCode_Gu [subid]="'ckb_CoopCode_Gu'"
                layout="relative" [forcedEnabledMode]="'true'" [(ngModel)]="kymw1800Model.gunma" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label label="ち" id="ckb_CoopCode_Chi" #ckb_CoopCode_Chi [subid]="'ckb_CoopCode_Chi'"
                layout="relative" [forcedEnabledMode]="'true'" [(ngModel)]="kymw1800Model.chiba" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label label="さ" id="ckb_CoopCode_Sa" #ckb_CoopCode_Sa [subid]="'ckb_CoopCode_Sa'"
                layout="relative" [forcedEnabledMode]="'true'" [(ngModel)]="kymw1800Model.saitama" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label label="とう" id="ckb_CoopCode_Tok" #ckb_CoopCode_Tok [subid]="'ckb_CoopCode_Tok'"
                layout="relative" [forcedEnabledMode]="'true'" [(ngModel)]="kymw1800Model.tokyo" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label label="な" id="ckb_CoopCode_Na" #ckb_CoopCode_Na [subid]="'ckb_CoopCode_Na'"
                layout="relative" [forcedEnabledMode]="'true'" [(ngModel)]="kymw1800Model.nagano" [tabindex]="0">
              </app-checkbox-label>
              <app-checkbox-label label="に" id="ckb_CoopCode_Ni" #ckb_CoopCode_Ni [subid]="'ckb_CoopCode_Ni'"
                layout="relative" [forcedEnabledMode]="'true'" [(ngModel)]="kymw1800Model.niigata"> [tabindex]="0"
              </app-checkbox-label>
              <app-checkbox-label label="ク" id="ckb_CoopCode_Ku" #ckb_CoopCode_Ku [subid]="'ckb_CoopCode_Ku'"
                layout="relative" [forcedEnabledMode]="'true'" [(ngModel)]="kymw1800Model.kuruco" [tabindex]="0">
              </app-checkbox-label>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_CSVOut" class="btn-primary" (click)="eventCSVOut_CLICKHandler()" forcedEnabledMode="true"
            [tabindex]="0">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>